module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "teams-lite@2x.897c9142.png" + "?" + Date.now();